import { QueryClient } from "@tanstack/react-query";

import { ApiError } from "./errors";

/**
 * Every read from the server goes through TanStack Query, with these defaults
 * (guide 4.9).
 *
 *   - Fresh for 30 seconds: moving between pages does not ask again at once.
 *   - Asked again when the window comes back: a counter computer left on a
 *     page for an hour shows fresh numbers the moment somebody uses it.
 *   - Retried only when the request never reached the server, at most twice.
 *     A 4xx is an answer, and asking again gets the same answer. Changes are
 *     never retried by themselves: the person presses the button again, with
 *     the same id (guide 4.7).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => error instanceof ApiError && error.isOffline && failureCount < 2,
      },
      mutations: { retry: false },
    },
  });
}
